import { render, staticRenderFns } from "./QuotesView.vue?vue&type=template&id=4e967970&scoped=true&"
import script from "./QuotesView.vue?vue&type=script&lang=js&"
export * from "./QuotesView.vue?vue&type=script&lang=js&"
import style0 from "./QuotesView.vue?vue&type=style&index=0&id=4e967970&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e967970",
  null
  
)

export default component.exports